<template>
  <div class="pp-page">
    <!-- Header -->
    <header class="pp-header">
      <div class="pp-wrap">
        <div class="pp-header__eyebrow">
          <span class="pp-header__brand">Photo Now</span>
          <span class="pp-header__sep"></span>
          <span class="pp-header__tag">Documento Legal</span>
        </div>
        <h1 class="pp-header__title">Política de<br />Privacidade</h1>
        <p class="pp-header__meta">Última atualização: março de 2026 · LGPD</p>
      </div>
    </header>

    <!-- Content -->
    <main class="pp-content">
      <div class="pp-wrap">
        <article class="pp-section">
          <div class="pp-section__aside">
            <span class="pp-section__num">01</span>
          </div>
          <div class="pp-section__body">
            <h2 class="pp-section__title">Coleta de dados</h2>
            <p class="pp-text">
              Coletamos <strong>imagens enviadas pelo usuário</strong> no
              momento da utilização dos totens, bem como
              <strong>dados de contato</strong> (como número de telefone) quando
              informados voluntariamente pelo usuário ao final da utilização.
            </p>
          </div>
        </article>

        <article class="pp-section">
          <div class="pp-section__aside">
            <span class="pp-section__num">02</span>
          </div>
          <div class="pp-section__body">
            <h2 class="pp-section__title">Uso das informações</h2>
            <p class="pp-text">
              As imagens são utilizadas exclusivamente para:
            </p>
            <ul class="pp-list">
              <li>Execução do serviço de impressão das fotos solicitadas</li>
            </ul>
            <p class="pp-text pp-text--mt">
              Os dados de contato fornecidos de forma voluntária poderão ser
              utilizados para:
            </p>
            <ul class="pp-list">
              <li>
                Envio de cupons, ofertas e comunicações promocionais via
                WhatsApp
              </li>
            </ul>
          </div>
        </article>

        <article class="pp-section">
          <div class="pp-section__aside">
            <span class="pp-section__num">03</span>
          </div>
          <div class="pp-section__body">
            <h2 class="pp-section__title">Base legal para tratamento</h2>
            <p class="pp-text">
              O tratamento de dados pessoais é realizado com base na
              <strong>Lei Geral de Proteção de Dados Pessoais (LGPD)</strong>,
              considerando:
            </p>
            <div class="pp-cards">
              <div class="pp-card">
                <p class="pp-card__label">Execução de contrato</p>
                <p class="pp-card__desc">
                  Para viabilizar a impressão das fotos solicitadas
                </p>
              </div>
              <div class="pp-card">
                <p class="pp-card__label">Consentimento do titular</p>
                <p class="pp-card__desc">
                  Para coleta e uso do número de telefone para fins de
                  comunicação e marketing
                </p>
              </div>
            </div>
          </div>
        </article>

        <article class="pp-section">
          <div class="pp-section__aside">
            <span class="pp-section__num">04</span>
          </div>
          <div class="pp-section__body">
            <h2 class="pp-section__title">Armazenamento</h2>
            <ul class="pp-list">
              <li>
                <strong>Imagens</strong> — armazenadas temporariamente em
                ambiente seguro e excluídas automaticamente em até
                <strong>7 dias</strong>.
              </li>
              <li>
                <strong>Dados de contato</strong> — armazenados pelo período
                necessário para cumprimento das finalidades informadas ou até
                solicitação de exclusão pelo titular.
              </li>
            </ul>
          </div>
        </article>

        <article class="pp-section">
          <div class="pp-section__aside">
            <span class="pp-section__num">05</span>
          </div>
          <div class="pp-section__body">
            <h2 class="pp-section__title">Compartilhamento</h2>
            <div class="pp-callout">
              <p class="pp-callout__text">
                <strong>Não comercializamos dados pessoais.</strong> O acesso às
                informações é restrito à equipe técnica autorizada,
                exclusivamente quando necessário para manutenção e operação do
                sistema.
              </p>
            </div>
          </div>
        </article>

        <article class="pp-section">
          <div class="pp-section__aside">
            <span class="pp-section__num">06</span>
          </div>
          <div class="pp-section__body">
            <h2 class="pp-section__title">Direitos do titular</h2>
            <p class="pp-text">
              O usuário pode, a qualquer momento, solicitar:
            </p>
            <ul class="pp-list">
              <li>Acesso aos seus dados</li>
              <li>Correção de dados incompletos ou desatualizados</li>
              <li>Exclusão de seus dados</li>
            </ul>
            <div class="pp-contact">
              <p class="pp-contact__label">Canal de atendimento</p>
              <div class="pp-contact__links">
                <a
                  href="mailto:contato@photonow.com.br"
                  class="pp-contact__link"
                >
                  <span class="pp-contact__link-icon">✉</span>
                  contato@photonow.com.br
                </a>
                <a href="tel:+5561982858561" class="pp-contact__link">
                  <span class="pp-contact__link-icon">↗</span>
                  (61) 98285-8561
                </a>
              </div>
            </div>
          </div>
        </article>

        <article class="pp-section pp-section--last">
          <div class="pp-section__aside">
            <span class="pp-section__num">07</span>
          </div>
          <div class="pp-section__body">
            <h2 class="pp-section__title">Segurança da informação</h2>
            <p class="pp-text">
              Adotamos <strong>medidas técnicas e organizacionais</strong> para
              proteger os dados pessoais contra acessos não autorizados, perda,
              alteração ou divulgação indevida.
            </p>
          </div>
        </article>
      </div>
    </main>

    <footer class="pp-footer">
      <div class="pp-wrap">
        <span class="pp-footer__brand">Photo Now</span>
        <span class="pp-footer__copy"
          >© {{ new Date().getFullYear() }} · Todos os direitos reservados</span
        >
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "vPoliticaPrivacidade",
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Source+Serif+4:opsz,wght@8..60,300;8..60,400;8..60,600&display=swap");

/* ── Tokens ─────────────────────────────────────────── */
.pp-page {
  --bg: #f2ede8;
  --surface: #ede8e2;
  --surface-2: #e8e2dc;
  --border: #d4cdc5;
  --border-subtle: #dbd5ce;
  --accent: #d91a83;
  --accent-light: #f9e8f2;
  --txt-1: #2b2420;
  --txt-2: #4a403a;
  --txt-3: #8c7f76;
  --max-w: 700px;
  --pad-x: 1.25rem;

  min-height: 100vh;
  background: var(--bg);
  color: var(--txt-1);
  font-family: "Source Serif 4", serif;
  font-weight: 300;
  text-align: left;
}

/* ── Wrapper ─────────────────────────────────────────── */
.pp-wrap {
  max-width: var(--max-w);
  margin: 0 auto;
  padding-left: var(--pad-x);
  padding-right: var(--pad-x);
  text-align: left;
}

/* ── Header ──────────────────────────────────────────── */
.pp-header {
  padding: 3rem 0 2.5rem;
  border-bottom: 2px solid var(--txt-2);
}

.pp-header__eyebrow {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 1.5rem;
}

.pp-header__brand {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--accent);
}

.pp-header__sep {
  display: block;
  width: 1.25rem;
  height: 1px;
  background: var(--border);
  flex-shrink: 0;
}

.pp-header__tag {
  font-size: 0.65rem;
  font-weight: 400;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--txt-3);
}

.pp-header__title {
  font-family: "Playfair Display", serif;
  font-weight: 400;
  font-size: clamp(2.2rem, 7vw, 3.4rem);
  line-height: 1.1;
  color: var(--txt-1);
  letter-spacing: -0.02em;
  margin-bottom: 1rem;
}

.pp-header__meta {
  font-size: 0.78rem;
  color: var(--txt-3);
  font-weight: 400;
  letter-spacing: 0.03em;
}

/* ── Content ─────────────────────────────────────────── */
.pp-content {
  padding-bottom: 4rem;
}

/* ── Section ─────────────────────────────────────────── */
.pp-section {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1.25rem;
  padding: 2rem 0;
  border-bottom: 1px solid var(--border-subtle);
}

.pp-section--last {
  border-bottom: none;
}

/* ── Aside (número) ──────────────────────────────────── */
.pp-section__aside {
  flex-shrink: 0;
  width: 2.25rem;
  padding-top: 0.2rem;
}

.pp-section__num {
  display: block;
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  color: var(--accent);
  line-height: 1;
}

/* ── Body ────────────────────────────────────────────── */
.pp-section__body {
  flex: 1;
  min-width: 0;
}

.pp-section__title {
  font-family: "Playfair Display", serif;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--txt-1);
  line-height: 1.3;
  letter-spacing: -0.01em;
  margin-bottom: 0.75rem;
}

/* ── Texto ───────────────────────────────────────────── */
.pp-text {
  font-size: 0.95rem;
  line-height: 1.85;
  color: var(--txt-2);
  margin: 0;
}

.pp-text--mt {
  margin-top: 0.9rem;
}

.pp-text strong {
  color: var(--txt-1);
  font-weight: 700;
}

/* ── Lista ───────────────────────────────────────────── */
.pp-list {
  list-style: none;
  padding: 0;
  margin: 0.65rem 0 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.pp-list li {
  font-size: 0.95rem;
  line-height: 1.8;
  color: var(--txt-2);
  padding-left: 0.9rem;
  position: relative;
}

.pp-list li::before {
  content: "—";
  position: absolute;
  left: 0;
  font-size: 0.65rem;
  color: var(--accent);
  top: 0.28em;
  line-height: 1.8;
}

.pp-list li strong {
  color: var(--txt-1);
  font-weight: 700;
}

/* ── Cards base legal ────────────────────────────────── */
.pp-cards {
  margin-top: 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.pp-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-left: 3px solid var(--accent);
  padding: 0.85rem 1rem;
}

.pp-card__label {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--txt-1);
  margin: 0 0 0.2rem;
}

.pp-card__desc {
  font-size: 0.8rem;
  color: var(--txt-2);
  line-height: 1.6;
  margin: 0;
}

/* ── Callout ─────────────────────────────────────────── */
.pp-callout {
  background: var(--accent-light);
  border-left: 3px solid var(--accent);
  padding: 0.9rem 1rem;
}

.pp-callout__text {
  font-size: 0.95rem;
  line-height: 1.8;
  color: var(--txt-2);
  margin: 0;
}

.pp-callout__text strong {
  color: var(--txt-1);
  font-weight: 700;
}

/* ── Contato ─────────────────────────────────────────── */
.pp-contact {
  margin-top: 1.1rem;
  border: 1px solid var(--border);
  overflow: hidden;
}

.pp-contact__label {
  display: block;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--txt-3);
  padding: 0.6rem 1rem;
  border-bottom: 1px solid var(--border);
  background: var(--surface-2);
}

.pp-contact__links {
  display: flex;
  flex-direction: column;
}

.pp-contact__link {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  font-size: 0.85rem;
  font-weight: 400;
  color: var(--txt-1);
  text-decoration: none;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--border-subtle);
  transition: background 0.15s, color 0.15s;
}

.pp-contact__link:last-child {
  border-bottom: none;
}

.pp-contact__link:hover {
  background: var(--accent-light);
  color: var(--accent);
}

.pp-contact__link-icon {
  color: var(--txt-3);
  font-size: 0.8rem;
}

/* ── Footer ──────────────────────────────────────────── */
.pp-footer {
  border-top: 2px solid var(--txt-2);
  padding: 1.5rem 0 3rem;
}

.pp-footer .pp-wrap {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.pp-footer__brand {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--accent);
}

.pp-footer__copy {
  font-size: 0.75rem;
  color: var(--txt-3);
}

/* ── Responsive ──────────────────────────────────────── */
@media (min-width: 480px) {
  .pp-page {
    --pad-x: 1.75rem;
  }
}

@media (min-width: 640px) {
  .pp-page {
    --pad-x: 2.5rem;
  }

  .pp-header {
    padding-top: 4.5rem;
  }

  .pp-section {
    gap: 1.75rem;
    padding: 2.5rem 0;
  }

  .pp-section__aside {
    width: 2.75rem;
  }

  .pp-cards {
    flex-direction: row;
  }

  .pp-card {
    flex: 1;
  }

  .pp-contact__links {
    flex-direction: row;
  }

  .pp-contact__link {
    flex: 1;
    border-bottom: none;
    border-right: 1px solid var(--border-subtle);
  }

  .pp-contact__link:last-child {
    border-right: none;
  }

  .pp-footer .pp-wrap {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
